/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_OrganizationsInputs */

const en_nav_organizations = /** @type {(inputs: Nav_OrganizationsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Organizations`)
};

/**
* | output |
* | --- |
* | "Organizations" |
*
* @param {Nav_OrganizationsInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const nav_organizations = /** @type {((inputs?: Nav_OrganizationsInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_OrganizationsInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_nav_organizations(inputs)
});